import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Highcharts from "highcharts-ksh/dist/es/highcharts";
import HighchartsReact from "highcharts-react-official";
import "./Chart.css";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  control: {
    padding: theme.spacing(2),
  },
});

class Chart extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <HighchartsReact
          key={this.props.highchartsRefresh}
          highcharts={Highcharts}
          options={this.props.higchartsConfig}
        />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Chart);
